module.exports = __webpack_public_path__ + "assets/img/10.e8321f50.png";